module.exports = __webpack_public_path__ + "static/media/foto3.4eebd897.png";